<template>
    <div class="modal fade" id="ModalLogin" tabindex="-1" role="dialog" aria-labelledby="Обратная связь" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="h5 heading heading_modal" id="ModalLoginLabel" v-if="!message">ВХОД В ЛИЧНЫЙ КАБИНЕТ</p>
                    <button type="button" class="modal-close btn btn-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <form id="LoginForm" method="post" action="/ajax_new/Forms/login/" @submit.prevent="submit" v-if="!message">
                        <div v-if="!message">
                            <div class="modal-body-content">
                                <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.login.$error }">
                                    <label for="LoginForm-login">
                                        Телефон
                                        <span class="color-red">*</span>
                                    </label>
<!--
                                    <input type="text" class="form-control" id="LoginForm-login" name="login" @blur="$v.login.$touch()"
                                           aria-describedby="Логин" v-model.trim="login" @input="setLogin($event.target.value)">
-->


                                  <masked-input class="form-control"
                                                :value="login"
                                                name="login"
                                                mask="+7 (999) 999 99 99" placeholder="+7 (___) ___ __ __"
                                                type="text"
                                                ref="maskedPhone"
                                                id="LoginForm-login"
                                                @focus="$v.login.$reset"
                                                @blur="$v.login.$touch"
                                                @input="setLogin"/>


                                    <div class="invalid-input" v-if="!$v.login.required">
                                        Поле обязательно для заполнения
                                    </div>
                                    <div class="invalid-input" v-if="!$v.login.valid">
                                        {{ loginError[0].message }}
                                    </div>
                                </div>
                                <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.password.$error }">
                                  <label for="LoginForm-password">
                                    Пароль
                                    <span class="color-red">*</span>
                                  </label>
                                  <div class="input-group">
                                    <input  :type="showInput ? 'text' : 'password'"  class="form-control" name="password" @blur="$v.password.$touch()"
                                           aria-describedby="Пароль" id="LoginForm-password" v-model.trim="password" @input="setPassword($event.target.value)">

                                  <div @click="setText()"  class="input-group-addon">
                                    <i  v-if="!showInput" class="fa fas fa-eye"></i>
                                    <i   v-if="showInput" class="fa fas fa-eye-slash"></i>

                                  </div>
                                    </div>


                                  <div class="invalid-input" v-if="!$v.password.required">
                                        Поле обязательно для заполнения
                                    </div>
                                    <div class="invalid-input" v-if="!$v.password.valid">
                                        {{ passwordError[0].message }}
                                    </div>
                                    <small class="form-text text-muted pt-2">
                                        <i class="icon icon-lock"></i>
                                        <a href="#ModalForgotPass" data-dismiss="modal" data-toggle="modal" data-target="#ModalForgotPass">
                                            Забыли пароль?
                                        </a>
                                    </small>
                                </div>
                            </div>
                            <div class="form-group form-group_modal modal-footer">
                                <button type="submit" class="btn btn-primary btn-block" :disabled="isAjax" v-loading="isAjax">Войти</button>
                            </div>
                            <div class="form-group form-group_modal modal-footer">
                                <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal"
                                        data-toggle="modal" data-target="#ModalRegister">Зарегистрироваться
                                </button>
                            </div>
                            <div class="alert alert-dismissable fade show alert-danger" role="alert" v-if="errors.length">
                                {{ errors[0].message }}
                            </div>
                        </div>
                    </form>
                    <div v-if="message">
                        <h3 class="py-3 text-center" v-if="message">
                            {{ message }}
                        </h3>
                        <div class="form-group form-group_modal">
                            <button class="btn btn-primary btn-block" data-dismiss="modal">ОК</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import MaskedInput from '../MaskedInput'
  export default {
    name: 'login',
    mixins: [validationMixin],
    components: {MaskedInput},
    data: function () {
      return {
        showInput: false,
        login: '',
        loginError: [],
        password: '',
        passwordError: [],
        isAjax: false,
        message: '',
        errors: []
      }
    },
    computed: {
      phoneValid() {
        return this.login.replace(/[^0-9]/g, '').length === 11
      }
    },
    validations: {
      login: {
        required,
        valid () {
          return this.loginError.length === 0
        }
      },
      password: {
        required,
        valid () {
          return this.passwordError.length === 0
        }
      }
    },
    methods: {
      setText(){
        this.showInput = !this.showInput;
      },
      setPwd(){
        this.showInput = false;
      },
      setLogin (value) {
        this.login = value
if(this.login.replace(/[^0-9]/g, '').length === 11) {
  localStorage.setItem("_phone", this.login);
}


        this.loginError = []
        this.$v.login.$touch()
      },
      setPassword (value) {
        this.password = value
        this.passwordError = []
        this.$v.password.$touch()
      },
      submit: async function (e) {
        this.errors = []
        this.loginError = []
        this.passwordError = []
        this.message = ''
        this.$v.$touch()

        let targetNode = e.target
        let action = targetNode.action

        if (!this.$v.$invalid) {
          let formData = new FormData(targetNode)

          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('login')

          formData.append('g-recaptcha-response', token)

          this.isAjax = true

          this.$http.post(action, formData).then(request => {
            this.isAjax = false

            if (request.data.status) {
              window.location.href = request.data.data.redirect
            } else {
              request.data.errors.forEach(element => {
                if (element.code === 'login') {

                  this.loginError.push(element)
                } else if (element.code === 'password') {
                  this.passwordError.push(element)
                } else {
                  this.errors.push(element)
                }
              })
            }
          }).catch(error => {
            this.isAjax = false

            console.error(error)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/forms/Login.vue